import React from "react";

import productService from "../services/productService";
import { showProcess, hideProcess, UserSession, getFileServer } from "../utils/util";
import { Galleria } from "primereact/galleria";
import Banner001 from "../img/Banner001.png";
import { useParams } from "react-router-dom";
import { InputNumber } from "primereact/inputnumber";
import shoppingCartService from "../services/shoppingCartService";
import { Ripple } from "primereact/ripple";
import accountService from "../services/accountService";
import cartEmpyy from "../img/cart-empty.svg";
import shop28SVG from "../img/shop-28.svg";

export default class ShoppingCart extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            shoppingCart: { lines: [] },
            windowWidth: window.innerWidth,
            fileServer: getFileServer(),
            editingField: null, // Controla qual campo está sendo editado
            tempValues: {}, // Armazena valores temporários durante edição
        };
    }

    async componentDidMount() {
        try {
            await showProcess();

            if (UserSession !== null && UserSession !== undefined) {
                const response = await shoppingCartService.getShoppingCart();
                if (response.status === 200) {
                    this.setState({ shoppingCart: response.data });
                    const responseBalance = await accountService.getBalance();
                    if (responseBalance.status === 200) {
                        await localStorage.setItem("balance", JSON.stringify(responseBalance.data));
                    }
                } else {
                    alert("ERRO AO CARREGAR PAGINA");
                }
            } else {
                var shoppingcart = JSON.parse(localStorage.getItem("shoppingCart"));
                if (shoppingcart === null || shoppingcart === undefined) {
                    shoppingcart = { lines: [] };
                }
                this.setState({ shoppingCart: shoppingcart });
            }

            window.addEventListener("resize", this.handleResize);
        } catch (err) {
            if (err.response) {
                console.log("status", err.response.status);
                console.log("headers", err.response.headers);
                console.log("data", err.response.data);
            } else {
                console.log("message", err.message);
            }
        }
        hideProcess();
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.handleResize);
    }

    handleResize = () => {
        this.setState({ windowWidth: window.innerWidth });
    };

    removeShoppcartLine = async (index) => {
        try {
            showProcess();
            if (UserSession !== null && UserSession !== undefined) {
                var shoppingCart = this.state.shoppingCart;
                shoppingCart.lines.splice(index, 1);
                var response = await shoppingCartService.create(shoppingCart);
                if (response.status === 200) {
                    this.props.refreshCart();
                }
            } else {
                var shoppingcart = this.state.shoppingCart;
                if (shoppingcart === null || shoppingcart === undefined) {
                    shoppingcart = { lines: [] };
                    return;
                }
                shoppingcart.lines.splice(index, 1);
                await localStorage.setItem("shoppingCart", JSON.stringify(shoppingcart));
                this.props.refreshCart();
            }
        } catch (ex) {
            if (ex.response !== undefined) {
                alert(ex.response.data);
            } else {
                alert(ex);
            }
        }
        hideProcess();
    };

    setQuantity = async (line, quantity) => {
        try {
            showProcess();
            var shoppingCart = this.state.shoppingCart;
            const index = shoppingCart.lines.findIndex((l) => l.id === line.id);
            shoppingCart.lines[index].quantity = quantity;
            shoppingCart.lines[index].totalAmount = shoppingCart.lines[index].amount * quantity;
            var response = await shoppingCartService.save(shoppingCart);
            this.setState({ shoppingCart: response.data });
        } catch (ex) {
            if (ex.response !== undefined) {
                alert(ex.response.data);
            } else {
                alert(ex);
            }
        }
        hideProcess();
    };

    conclude = async () => {
        try {
            showProcess();
            var response = await shoppingCartService.conclude(this.state.shoppingCart);
            if (response.status === 200) {
                window.location.href = "/payment";
            }
        } catch (ex) {
            if (ex.response !== undefined) {
                alert(ex.response.data);
            } else {
                alert(ex);
            }
        }
        hideProcess();
    };

    startEditField = (lineIndex, fieldName) => {
        const line = this.state.shoppingCart.lines[lineIndex];
        const fieldKey = `${lineIndex}-${fieldName}`;
        const currentValue = 
            fieldName === "name" ? (line.userName || UserSession?.name) :
            fieldName === "phone" ? (line.userCellphone || UserSession?.cellphone) :
            fieldName === "email" ? (line.userEmail || UserSession?.email) : "";
        
        this.setState(prevState => ({
            editingField: fieldKey,
            tempValues: {
                ...prevState.tempValues,
                [fieldKey]: currentValue
            }
        }));
    };

    updateTempValue = (lineIndex, fieldName, value) => {
        const fieldKey = `${lineIndex}-${fieldName}`;
        this.setState(prevState => ({
            tempValues: {
                ...prevState.tempValues,
                [fieldKey]: value
            }
        }));
    };

    finishEditField = async (lineIndex, fieldName, nextFieldKey = null) => {
        const fieldKey = `${lineIndex}-${fieldName}`;
        const newValue = this.state.tempValues[fieldKey];
        const line = this.state.shoppingCart.lines[lineIndex];
        const oldValue = 
            fieldName === "name" ? (line.userName || UserSession?.name) :
            fieldName === "phone" ? (line.userCellphone || UserSession?.cellphone) :
            fieldName === "email" ? (line.userEmail || UserSession?.email) : "";

        // Validar se mudou
        if (newValue === oldValue || !newValue || newValue.trim() === "") {
            this.setState({ editingField: nextFieldKey || null });
            return;
        }

        // Validar campo
        let isValid = true;
        if (fieldName === "email") {
            isValid = this.validateEmail(newValue);
            if (!isValid) {
                alert("Email inválido");
                this.setState({ editingField: nextFieldKey || null });
                return;
            }
        } else if (fieldName === "phone") {
            isValid = this.validatePhone(newValue);
            if (!isValid) {
                alert("Telefone inválido. Formato: (XX) 9XXXX-XXXX ou (XX) XXXX-XXXX");
                this.setState({ editingField: nextFieldKey || null });
                return;
            }
        } else if (fieldName === "name") {
            if (newValue.trim().length < 2) {
                alert("Nome deve ter pelo menos 2 caracteres");
                this.setState({ editingField: nextFieldKey || null });
                return;
            }
        }

        if (!isValid) {
            this.setState({ editingField: nextFieldKey || null });
            return;
        }

        try {
            showProcess();
            const shoppingCart = { ...this.state.shoppingCart };
            
            // Atualizar o valor no carrinho
            if (fieldName === "name") {
                shoppingCart.lines[lineIndex].userName = newValue;
            } else if (fieldName === "phone") {
                shoppingCart.lines[lineIndex].userCellphone = newValue.replace(/\D/g, "");
            } else if (fieldName === "email") {
                shoppingCart.lines[lineIndex].userEmail = newValue;
            }

            // Salvar via API
            const response = await shoppingCartService.save(shoppingCart);
            if (response.status === 200) {
                this.setState({ 
                    shoppingCart: response.data,
                    editingField: nextFieldKey || null 
                });
            }
        } catch (ex) {
            if (ex.response !== undefined) {
                alert("Erro ao atualizar: " + ex.response.data);
            } else {
                alert("Erro ao atualizar: " + ex.message);
            }
            this.setState({ editingField: nextFieldKey || null });
        }
        hideProcess();
    };

    handleKeyPress = (e, lineIndex, fieldName) => {
        if (e.key === "Enter") {
            this.finishEditField(lineIndex, fieldName);
        }
    };

    handleKeyDown = (e, lineIndex, fieldName, nextFieldKey) => {
        if (e.key === "Tab") {            
            this.finishEditField(lineIndex, fieldName, nextFieldKey);
        }
    };

    validateEmail = (email) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    };

    validatePhone = (phone) => {
        const phoneRegex = /^(\(\d{2}\)\s?\d{4,5}-\d{4}|\d{10,11})$/;
        return phoneRegex.test(phone.replace(/\D/g, "")) && phone.replace(/\D/g, "").length >= 10;
    };

    maskPhone = (value) => {
        try {
            return value
                .replace(/\D/g, "")
                .replace(/(\d{2})(\d)/, "($1) $2")
                .replace(/(\d{5})(\d)/, "$1-$2")
                .replace(/(-\d{4})\d+?$/, "$1");
        } catch (e) {
            return "";
        }
    };

    render() {
        const isMobile = this.state.windowWidth < 1215;

        if (
            this.state.shoppingCart === null ||
            this.state.shoppingCart === undefined ||
            this.state.shoppingCart === "" ||
            this.state.shoppingCart.lines === null ||
            this.state.shoppingCart.lines === undefined ||
            this.state.shoppingCart.lines.length === 0
        ) {
            return (
                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        padding: "50px",
                    }}
                >
                    <div style={{position: "relative"}}>
                        <img src={cartEmpyy} alt="Carrinho Vazio" style={{width: "300px", height: "300px"}} />
                        <img src={shop28SVG} alt="Carrinho Vazio" style={{ position: "absolute", top: "50%", left: "50%", width: "150px", height: "150px" }} />
                    </div>
                    
                    <label
                        style={{
                            color: "#000000",
                            fontSize:  "24px",
                            textAlign: "center",
                            marginTop: "50px",
                            fontWeight: "bold",
                        }}
                    >
                        Seu carrinho está vazio
                    </label>
                    <label
                        style={{
                            color: "#000000",
                            fontSize: "18px",
                            textAlign: "center",
                        }}
                    >
                        Escolha um cartão-presente para você ou para presentear alguém e adicione ao
                        seu carrinho
                    </label>
                    <button
                        style={{
                            backgroundColor: " #411172",
                            marginTop: "50px",
                            borderRadius: "13px",
                            color: "#ffffff",
                            padding: "10px 30px",
                            fontSize: "18px",
                            textAlign: "center",
                            cursor: "pointer",
                            fontWeight: "600",
                        }}
                        onClick={() => (window.location.href = "/")}
                    >
                        Comprar<br/>um<br/>Cartão-Presente
                    </button>
                </div>
            );
        }

        return (
            <>
                <div style={{width: "100%", borderBottom: "1px solid #ccc", padding: "0px 0px 20px", marginBottom: "20px"}}>
                    <label style={{ fontSize: "25px", fontWeight: "bold", marginBottom: "20px", color: "#3D4655" }}>Meu Carrinho</label>
                    <br />
                    <label color="#3D4655">(Todos os campos são obrigatórios, a menos que indicado de outra forma)</label>
                </div>

                <div style={{width: "100%", 
                             height: "50px",
                             marginBottom: "20px",
                             position: "relative",
                             }}>
                    <div style={{backgroundColor: "var(--unnamed-color-411172)", 
                                 color: "#ffffff",
                                 width: "fit-content", 
                                 padding: "15px 20px",
                                 borderTopRightRadius: "25px",
                                 borderBottomRightRadius: "25px",
                                 fontWeight: "bold",
                                 position: "absolute",
                                 textAlign: "center",
                                 left: "0px",
                                 width: "170px",
                                 borderRight: "8px solid #ffffff",
                                 zIndex: 1,
                                 fontSize: "14px",
                                 }}>
                        Carrinho
                    </div>
                    <div style={{backgroundColor: "var(--unnamed-color-411172)", 
                                 color: "#ffffff",
                                 width: "fit-content", 
                                 padding: "15px 20px",
                                 borderTopRightRadius: "25px",
                                 borderBottomRightRadius: "25px",
                                 fontWeight: "bold",
                                 position: "absolute",
                                 left: "155px",
                                 width: "170px",
                                 textAlign: "center",
                                 fontSize: "14px",
                                 }}>
                        Pagamento
                    </div>
                </div>

                <div
                    style={{
                        display: "flex",
                        flexDirection: isMobile ? "column" : "row",
                        alignItems: isMobile ? "center" : "flex-start",
                        justifyContent: "center",
                        width: "100%",
                    }}
                >
                    
                    
                    <div
                        style={{
                            width: isMobile ? "100%" : "calc(100% - 400px)",
                            backgroundColor: "#ffffff",
                            borderRight: isMobile ? "none" : "1px solid #707070",
                            padding: isMobile ? "10px" : "0px 10px 0px 0px",
                        }}
                    >
                        {this.state.shoppingCart.lines.map((l, i) => (
                            <table
                                key={i}
                                cellPadding={0}
                                cellSpacing={0}
                                style={{
                                    width: "100%",
                                    marginBottom: "20px",
                                    borderCollapse: "collapse",
                                    tableLayout: "fixed",
                                    overflowWrap: "break-word",
                                }}
                            >
                                <tr>
                                    <th
                                        style={{
                                            borderBottom: "2px solid #ccc",
                                            padding: isMobile ? "5px 10px" : "10px 20px",
                                            textAlign: "left",
                                            width: isMobile ? "100%" : "400px",
                                            display: isMobile ? "block" : "table-cell",
                                        }}
                                    >
                                        <span
                                            style={{
                                                fontSize: isMobile ? "16px" : "22px",
                                                color: "var(--unnamed-color-411172)",
                                                fontWeight: "700",
                                            }}
                                        >
                                            {l.product.displayName}
                                        </span>
                                    </th>
                                    <th
                                        style={{
                                            borderBottom: "2px solid #ccc",
                                            padding: isMobile ? "5px 10px" : "10px 20px",
                                            display: isMobile ? "block" : "table-cell",
                                            textAlign: isMobile ? "left" : "right",
                                        }}
                                    >
                                        <div
                                            style={{
                                                alignItems: "center",
                                                display: "flex",
                                                justifyContent: isMobile ? "space-between" : "flex-end",
                                                flexWrap: "wrap",
                                            }}
                                        >
                                            <span
                                                style={{
                                                    fontSize: isMobile ? "16px" : "18px",
                                                    color: "green",
                                                }}
                                            >
                                                R$
                                                {l.product.amount.toLocaleString("pt-BR", {
                                                    minimumFractionDigits: 2,
                                                    maximumFractionDigits: 2,
                                                })}
                                            </span>
                                            <button
                                                style={{
                                                    border: "none",
                                                    backgroundColor: "transparent",
                                                    color: "#000141",
                                                    marginLeft: isMobile ? "0" : "15px",
                                                    marginTop: isMobile ? "10px" : "0",
                                                }}
                                                onClick={() => this.removeShoppcartLine(i)}
                                            >
                                                <span
                                                    className="pi pi-trash"
                                                    style={{ fontSize: "24px" }}
                                                />
                                                <br />
                                                <span style={{ fontSize: "12px", fontWeight: "bold" }}>
                                                    Remover
                                                </span>
                                            </button>
                                        </div>
                                    </th>
                                </tr>

                                <tr style={{ display: isMobile ? "block" : "table-row" }}>
                                    <td
                                        style={{
                                            padding: "20px",
                                            borderBottom: "1px solid #707070",
                                            display: isMobile ? "block" : "table-cell",
                                            width: isMobile ? "100%" : "auto",
                                            textAlign: "center",
                                        }}
                                    >
                                        <img
                                            src={`${this.state.fileServer}/cards/${l.product.id}.png`}
                                            alt="Gamers Fans"
                                            style={{
                                                width: isMobile ? "100%" : "360px",
                                                maxWidth: "300px",
                                                height: "auto",
                                            }}
                                        />
                                        <div style={{ textAlign: "center", marginTop: "20px" }}>
                                            <span style={{ color: "#707070", fontSize: "12px", marginBottom: "5px", display: "block" }}>
                                                Quantidade (1 - 10)
                                            </span>
                                            <br />
                                            <InputNumber
                                                value={l.quantity}
                                                onValueChange={(e) => this.setQuantity(l, e.value)}
                                                showButtons
                                                buttonLayout="horizontal"
                                                step={1}
                                                incrementButtonIcon="pi pi-plus"
                                                decrementButtonIcon="pi pi-minus"
                                                min={1}
                                                max={10}
                                                className="app-product-quantity-input"
                                            />
                                        </div>
                                    </td>

                                    <td
                                        style={{
                                            padding: "20px",
                                            borderBottom: "1px solid #707070",
                                            display: isMobile ? "block" : "table-cell",
                                            width: isMobile ? "100%" : "auto",
                                            verticalAlign: "top",
                                        }}
                                    >
                                        <table style={{ width: "100%", borderCollapse: "collapse" }}>
                                            <tr>
                                                <th
                                                    colSpan={2}
                                                    style={{
                                                        borderBottom: "1px solid #707070",
                                                        padding: "10px 0px",
                                                        textAlign: "left",
                                                    }}
                                                >
                                                    <span
                                                        style={{ fontSize: "18px", color: "#000141" }}
                                                    >
                                                        Informações do Destinatário
                                                    </span>
                                                </th>
                                            </tr>
                                            <tr style={{ display: isMobile ? "block" : "table-row" }}>
                                                <td
                                                    style={{
                                                        padding: "10px 0px",
                                                        display: isMobile ? "block" : "table-cell",
                                                        width: isMobile ? "100%" : "50%",
                                                    }}
                                                >
                                                    <input
                                                        placeholder="Primeiro Nome"
                                                        style={{
                                                            width: "100%",
                                                            border: "1px solid #707070",
                                                            fontSize: "14px",
                                                            borderRadius: "20px",
                                                            padding: "10px",
                                                        }}
                                                        readOnly={this.state.editingField !== `${i}-name`}
                                                        value={
                                                            this.state.editingField === `${i}-name` 
                                                                ? this.state.tempValues[`${i}-name`]
                                                                : (l.userName || UserSession?.name)
                                                        }
                                                        onMouseDown={() => this.startEditField(i, "name")}
                                                        onFocus={() => this.startEditField(i, "name")}
                                                        onChange={(e) => this.updateTempValue(i, "name", e.target.value)}
                                                        onBlur={() => this.finishEditField(i, "name")}
                                                        onKeyPress={(e) => this.handleKeyPress(e, i, "name")}
                                                        onKeyDown={(e) => this.handleKeyDown(e, i, "name", `${i}-phone`)}
                                                    />
                                                </td>
                                                <td
                                                    style={{
                                                        padding: "10px 0px",
                                                        display: isMobile ? "block" : "table-cell",
                                                        width: isMobile ? "100%" : "50%",
                                                    }}
                                                >
                                                    <input
                                                        placeholder="Telefone"
                                                        style={{
                                                            width: "100%",
                                                            border: "1px solid #707070",
                                                            fontSize: "14px",
                                                            borderRadius: "20px",
                                                            padding: "10px",
                                                        }}
                                                        readOnly={this.state.editingField !== `${i}-phone`}
                                                        value={
                                                            this.state.editingField === `${i}-phone`
                                                                ? this.state.tempValues[`${i}-phone`]
                                                                : this.maskPhone(l.userCellphone || UserSession?.cellphone)
                                                        }
                                                        onMouseDown={() => this.finishEditField(this.state.editingField?.split('-')[0], this.state.editingField?.split('-')[1], `${i}-phone`) || this.startEditField(i, "phone")}
                                                        onFocus={() => this.startEditField(i, "phone")}
                                                        onChange={(e) => this.updateTempValue(i, "phone", e.target.value)}
                                                        onBlur={() => this.finishEditField(i, "phone")}
                                                        onKeyPress={(e) => this.handleKeyPress(e, i, "phone")}
                                                        onKeyDown={(e) => this.handleKeyDown(e, i, "phone", `${i}-email`)}
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td colSpan="2" style={{ padding: "10px 0px" }}>
                                                    <input
                                                        placeholder="E-mail do destinatário"
                                                        style={{
                                                            width: "100%",
                                                            border: "1px solid #707070",
                                                            fontSize: "14px",
                                                            borderRadius: "20px",
                                                            padding: "10px",
                                                        }}
                                                        readOnly={this.state.editingField !== `${i}-email`}
                                                        value={
                                                            this.state.editingField === `${i}-email`
                                                                ? this.state.tempValues[`${i}-email`]
                                                                : (l.userEmail || UserSession?.email)
                                                        }
                                                        onMouseDown={() => this.finishEditField(this.state.editingField?.split('-')[0], this.state.editingField?.split('-')[1], `${i}-email`) || this.startEditField(i, "email")}
                                                        onFocus={() => this.startEditField(i, "email")}
                                                        onChange={(e) => this.updateTempValue(i, "email", e.target.value)}
                                                        onBlur={() => this.finishEditField(i, "email")}
                                                        onKeyPress={(e) => this.handleKeyPress(e, i, "email")}
                                                        onKeyDown={(e) => this.handleKeyDown(e, i, "email")}
                                                    />
                                                </td>
                                            </tr>
                                            {/*<tr>
            <td colSpan='2' style={{ padding: "10px 0px" }}>
                <textarea 
                placeholder='Digite a mensagem (opcional)' 
                style={{ 
                    width: '100%', 
                    border: '1px solid #707070', 
                    fontSize: '21px', 
                    borderRadius: '20px', 
                    padding: '10px', 
                    resize: 'vertical' 
                }} 
                rows={5}
                ></textarea>
                <br />
                <span style={{ float: 'right' }}>0 de 350 caracteres inseridos</span>
            </td>
            </tr>*/}
                                        </table>
                                    </td>
                                </tr>
                            </table>
                        ))}
                    </div>

                    <div
                        style={{
                            width: isMobile ? "100%" : "400px",
                            padding: isMobile ? "20px" : "0px 20px",
                        }}
                    >
                        <div
                            style={{
                                border: "1px solid var(--unnamed-color-411172)",
                                borderRadius: "12px",
                                color: "var(--unnamed-color-411172)",
                                padding: "25px",
                                fontSize: "18px",
                                textAlign: "center",
                                fontWeight: "700",
                            }}
                        >
                            Resumo Pedido
                        </div>
                        <table
                            style={{ width: "100%", marginTop: "50px" }}
                            cellPadding={0}
                            cellSpacing={0}
                        >
                            <tr>
                                <td
                                    style={{
                                        textAlign: "left",
                                        fontSize: "18px",
                                        padding: "10px 0px",
                                        borderBottom: "1px solid #3D4655",
                                        color: "#3D4655",
                                        fontWeight: "600",
                                    }}
                                >
                                    Subtotal
                                </td>
                                <td
                                    style={{
                                        textAlign: "right",
                                        fontSize: "18px",
                                        padding: "10px 0px",
                                        borderBottom: "1px solid #3D4655",
                                        color: "#3D4655",
                                        fontWeight: "600",
                                    }}
                                >
                                    R$
                                    {this.state.shoppingCart.lines
                                        .reduce((a, b) => a + b.totalAmount, 0)
                                        .toLocaleString("pt-BR", {
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2,
                                        })}
                                </td>
                            </tr>
                            <tr>
                                <td
                                    style={{
                                        textAlign: "left",
                                        fontSize: "18px",
                                        padding: "10px 0px",
                                        color: "#3D4655",
                                        fontWeight: "600",
                                    }}
                                >
                                    Total
                                </td>
                                <td
                                    style={{
                                        textAlign: "right",
                                        fontSize: "18px",
                                        padding: "10px 0px",
                                        color: "#3D4655",
                                        fontWeight: "600",
                                    }}
                                >
                                    R$
                                    {this.state.shoppingCart.lines
                                        .reduce((a, b) => a + b.totalAmount, 0)
                                        .toLocaleString("pt-BR", {
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2,
                                        })}
                                </td>
                            </tr>
                        </table>
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "center",
                                marginTop: "50px",
                            }}
                        >
                            <button
                                style={{
                                    backgroundColor: " #411172",
                                    borderRadius: "12px",
                                    color: "#ffffff",
                                    fontSize: "18px",
                                    textAlign: "center",
                                    width: "fit-content",
                                    padding: "10px 30px", 
                                    cursor: "pointer",
                                    fontWeight: "600",

                                }}
                                onClick={() => this.conclude()}
                            >
                                Prossiga para<br/>pagamento
                            </button>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}
